export const raffle = {
  raffleTitle: "Rifas",
  raffleBtnMyTickets: "Mis Tickets",
  rafflePrize: "Premio",
  raffleBtnBuy: "Comprar Ticket",
  raffleStatus: "ACTIVO",
  raffleModalTitle: "Comprar Tickets para ",
  raffleModalPrice: "Precio del Ticket",
  raffleModalTotalPrice: "PRECIO TOTAL",
  raffleModalQuantity: "Ingresa un número",
  raffleModalBtnBuy: "Comprar Ticket(s)",
  raffleModalBuyQuantity: "Cuantos tickets deseas comprar?",
  raffleModalChooseNumber: "Escoger número",
  raffleModalChooseRandom: "Número aleatorio",
  raffleModalBackBtn: "Volver",
  raffleTicketPurchase: "¡Compra exitosa!",
  raffleTicketCreatedMessage: "Por favor, ingresa un número válido para cada ticket.",
  raffleTicketPurchaseError: "Error al comprar el ticket, por favor, intenta de nuevo más tarde.",
  raffleErrorMessage: "Error al comprar el ticket.",
};
